'use client';

import { FC, useEffect } from 'react';

import { Markdown } from '@/components/common';
import { useTextStream } from '@/hooks/useTextStream';

interface Props {
  markdownText: string;
  onProcessed?: () => void;
  onProcessCompleted?: () => void;
}

const LastBotMessage: FC<Props> = ({
  markdownText,
  onProcessed,
  onProcessCompleted,
}) => {
  const { displayedText, isComplete } = useTextStream({
    textStream: markdownText,
    mode: 'typewriter',
    speed: 80,
    characterChunkSize: 10,
  });

  useEffect(() => {
    onProcessed?.();
  }, [displayedText, onProcessed]);

  useEffect(() => {
    if (isComplete) {
      onProcessCompleted?.();
    }
  }, [isComplete, onProcessCompleted]);

  return (
    <div className='w-full min-w-0 max-w-full'>
      <Markdown
        revealStreaming
        className='prose prose-sm prose-chat-sm md:prose-base dark:prose-invert prose-h2:!mt-0 prose-h2:!scroll-m-0 max-w-none min-w-0'
      >
        {displayedText}
      </Markdown>
    </div>
  );
};

export { LastBotMessage };
